// API Configuration for both development and production
// In development: React dev server (3000) needs to proxy to API server (4000)
// In production: Everything is hosted at nlfx-cable.luknai.com

const isDevelopment = process.env.NODE_ENV === 'development';
const isEmbedded = window.location.hostname === 'www.nlfxpro.com' || window.location.hostname === 'nlfxpro.com' || window.location.hostname === 'nlfx-cable.luknai.com';

// Prefer explicit env in production to ensure absolute calls from embedded host
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
  || (isDevelopment ? 'http://localhost:4000' : 'https://nlfx-cable.luknai.com');

// Ensure we have a valid API_BASE_URL for embedded environment
const finalApiBaseUrl = API_BASE_URL || 'https://nlfx-cable.luknai.com';

console.log('🔧 [CONFIG] Environment setup:', {
  isDevelopment,
  isEmbedded,
  hostname: window.location.hostname,
  API_BASE_URL: finalApiBaseUrl,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  NODE_ENV: process.env.NODE_ENV,
  fullUrl: window.location.href,
  userAgent: navigator.userAgent
});

const API_ENDPOINTS = {
  CONFIGS: `${finalApiBaseUrl}/api/configs`,
  PUBLIC_CONFIGS: `${finalApiBaseUrl}/api/public-configs`,
  PRICING_CONFIG: `${finalApiBaseUrl}/api/pricing-config`,
  COMPATIBILITY_CONFIG: `${finalApiBaseUrl}/api/compatibility-config`,
  AUTH_LOGIN: `${finalApiBaseUrl}/api/auth/login`,
  AUTH_LOGOUT: `${finalApiBaseUrl}/api/auth/logout`,
  CALCULATE_PRICE: `${finalApiBaseUrl}/api/calculate-price`,
  UPLOAD_DIAGRAM: `${finalApiBaseUrl}/api/upload-diagram`,
  UPLOAD_LOGO: `${finalApiBaseUrl}/api/upload-logo`,
  BIGCOMMERCE_CART: `${finalApiBaseUrl}/api/bigcommerce-cart`,
  PANEL_BIGCOMMERCE_CART: `${finalApiBaseUrl}/api/panel-bigcommerce-cart`,
  EC2_IMAGE_GENERATOR: process.env.REACT_APP_EC2_IMAGE_GENERATOR_URL || finalApiBaseUrl
};

console.log('🔧 [CONFIG] API_ENDPOINTS:', API_ENDPOINTS);

const config = {
  API_BASE_URL: finalApiBaseUrl,
  API_ENDPOINTS,
  isDevelopment,
  isEmbedded
};

module.exports = { config, API_ENDPOINTS };